import { Protocol } from '../Protocol';

export class SampleCourseProtocol {
  public static readonly GET_SAMPLE_COURSE: string = `${Protocol.YATUNG_API_ROOT}/sample/profile`;
  public static readonly GET_SAMPLE_COURSE_BY_ID: string = `${Protocol.YATUNG_API_ROOT}/sample/profile`;
}
